import { render, staticRenderFns } from "./PlanTiers.vue?vue&type=template&id=6d69a724&scoped=true"
import script from "./PlanTiers.vue?vue&type=script&lang=js"
export * from "./PlanTiers.vue?vue&type=script&lang=js"
import style0 from "./PlanTiers.vue?vue&type=style&index=0&id=6d69a724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d69a724",
  null
  
)

export default component.exports